import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ClientService from "../../../rest/clientService";
import GradeSelect from "../../../components/reusables/gradeSelect";
import ModalInfo from "../../../components/lib/modalInfo";
import { RiErrorWarningLine } from "react-icons/ri";

const StudentTurnStep = ({ initialGrade = "", initialTurnIds = [], onSubmit, onDirty }) => {
    const [preferences, setPreferences] = useState(null);
    const [allTurns, setAllTurns] = useState([]);

    useEffect(() => {
        Promise.all([
            ClientService.getClientAdminPreferences(),
            ClientService.getTurns(),
        ]).then(([prefs, turns]) => {
            setPreferences(prefs);
            setAllTurns(turns || []);
        });
    }, []);

    const formik = useFormik({
        initialValues: {
            grade: initialGrade,
            turnIds: initialTurnIds,
        },
        validationSchema: Yup.object({
            grade: Yup.string().required("Série é um campo obrigatório"),
        }),
        onSubmit: (values) => {
            onSubmit({ grade: values.grade, turnIds: values.turnIds, allTurns });
        },
    });

    const handleToggleTurn = (turnId) => {
        const current = formik.values.turnIds;
        const next = current.includes(turnId)
            ? current.filter(id => id !== turnId)
            : [...current, turnId];
        formik.setFieldValue("turnIds", next);
        onDirty();
    };

    return (
        <form data-step-form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
            <div>
                <div className="flex items-center justify-between mb-1">
                    <p>Série</p>
                    <ModalInfo icon={<RiErrorWarningLine />} content="Campo Obrigatório!" />
                </div>
                <GradeSelect
                    name="grade"
                    value={formik.values.grade}
                    onChange={(e) => { formik.handleChange(e); onDirty(); }}
                    onBlur={formik.handleBlur}
                    gradesString={preferences?.grades}
                    touched={formik.touched.grade}
                    error={formik.errors.grade}
                />
                {formik.touched.grade && formik.errors.grade && (
                    <p className="text-red-500 text-xs mt-1">{formik.errors.grade}</p>
                )}
            </div>

            <div className="mt-2">
                <p className="font-medium mb-1">Turnos de Refeição</p>
                <p className="text-xs text-gray-400 mb-3">
                    Selecione os turnos em que este aluno faz refeições. Deixe em branco para permitir qualquer turno.
                </p>
                {allTurns.length === 0 ? (
                    <p className="text-sm text-gray-400 text-center py-4">Nenhum turno cadastrado.</p>
                ) : (
                    <div className="space-y-2">
                        {allTurns.map(turn => {
                            const checked = formik.values.turnIds.includes(turn.turnId);
                            return (
                                <label
                                    key={turn.turnId}
                                    className="flex items-center gap-3 py-2 px-3 rounded-lg border border-slate-100 hover:bg-slate-50 cursor-pointer transition-colors"
                                >
                                    <input
                                        type="checkbox"
                                        checked={checked}
                                        onChange={() => handleToggleTurn(turn.turnId)}
                                        className="w-4 h-4 accent-custom_blue"
                                    />
                                    <div className="flex-1">
                                        <p className="text-sm font-semibold text-gray-800">{turn.name}</p>
                                        <p className="text-xs text-gray-400">
                                            {turn.startTime || turn.start} – {turn.endTime || turn.end}
                                        </p>
                                    </div>
                                </label>
                            );
                        })}
                    </div>
                )}
            </div>
        </form>
    );
};

export default StudentTurnStep;
